import axios from "axios";
import axiosInstance from "./api_helper";
import config from "../helpers/config";

const productService = {
    search: async (query) => {
        return axiosInstance.post(`/api/products/search`, JSON.stringify(query));
    },

    findBySupplier: async (supplierId, page, size) => {
        return axiosInstance.get(`/api/products/supplier/${supplierId}?page=${page}&size=${size}`);
    },

    delete: async (id) => {
        return axiosInstance.delete(`/api/products/${id}`);
    },

    checkBarcode: async (barcode) => {
        return axiosInstance.get(`/api/products/barcode/${barcode}`);
    },

    save: async (formData) => {
        return axios.post(`${config.baseURL}/api/products`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
            }
        });
    },

    findAll: async () => {
        const response = await axiosInstance.get(`/api/products`);
        return response.data;
    },

    update: async (formData) => {
        return axios.put(`${config.baseURL}/api/products`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
            }
        });
    },
    
    upload: async (payload) => {

        return axiosInstance.post(`/api/products/upload`, payload.formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    
    updatePrice: async ({ id, userPrice }) => {
        try {
            return await axiosInstance.patch(`/api/products/${id}/price`, { userPrice });
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }

};
export default productService;
